import { http } from 'utils'

import { SET_LIST } from 'vx/mutations'

const state = {
  retainers: []
}

const getters = {
  retainers: state => state.retainers,

  getById: (state) => (id) => {
    return state.retainers.find(retainer => retainer.id === id)
  }
}

const actions = {
  getRetainers ({ commit }, payload) {
    return http.get(`/retainers/list`, {params: payload}).then(response => {
      commit(SET_LIST, response.data.data)

      return response
    })
  },
}

const mutations = {
  [SET_LIST] (state, retainers) {
    state.retainers = retainers
  }
}

export default {
  namespaced: true, state, getters, actions, mutations
}
